import React, { useCallback,useMemo,useEffect, useRef, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import { Box,
  IconButton,
  Typography,
  Tooltip,
} from '@mui/material';
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';
import {List } from '@mui/icons-material';
import Modal from 'react-bootstrap/Modal';
import Moment from 'react-moment';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Request from './Request';

const CustomTable = () => {
  const navigate = useNavigate();   
  const [newRequest, setNewRequest] = useState(false);
  const [existRequest, setExistRequest] = useState(false);
  const [showDetailsId , setShowDetailsId] = useState(false);
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const [columnFilters, setColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    subject: 'contains',
    refnum : 'contains',
    status: 'contains',
    type: 'contains',
    createdat: 'lessThan',
    updatedat: 'lessThan'
  });
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });

  const findFilterCondition = (name) =>{
    var condition = '';
    if(columnFilterFns[name]){
      condition = columnFilterFns[name];
    }
    return condition;
  }

  const fetchDataFromAPI = async (reset=false) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    
    let filterQuery='';
    let sorterQuery='';

    if(!reset){
      if(columnFilters.length>0){
        columnFilters.forEach(element => {
          filterQuery+=`&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
        });
      }
      if(sorting.length > 0){
        sorting.forEach(element => {
          sorterQuery+=`&sortby=${element.id}&orderby=${element.desc?'desc':'asc'}`;
        });
      }
    }else{
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }

    //Get Request List
    //api/account/request
    let url = `/account/request?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    await Axios.get(url)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setData(response.data?.data.requests.items??[]);
          setRowCount(response.data?.data.requests.count);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };


  useEffect(() => {
    fetchDataFromAPI();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting
  ]);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'refnum',
        header:  "Refnum #",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorFn: (row) => row.subject,
        id: 'subject',
        // enableColumnFilter: false,
        // enableSorting: false,
        // enableColumnFilterModes: false,
        header: 'Subject',
        enableEditing : false,
        size:50,
        Cell: ({ cell, row }) => (
          // <a href="#">
          //   <img style={{ maxHeight: "60px" }} src={AuthVerify.getImageLink(row.original.imageurl)} alt="Product" />
          // </a>
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'type',
        header:  "Type",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'createdat',
        header:  "Created Date",
        enableColumnFilterModes: true,
        filterFn: 'lessThan',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue() && cell.getValue().length>0 ? <Moment date={cell.getValue()} format="YYYY-MM-DD HH:mm:ss"/> : ""}</Typography>
        ),
        Filter: ({ column, header, table }) => ( 
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <input
              type="date"
              style={{margin:'6px 10px 3px 0',border:'1px solid #ddd',padding:'4px 0',color:'#777',fontSize:'13px'}}
              onChange={(newValue) => {
                column.setFilterValue(newValue.target.value);
              }}
              value={column.getFilterValue()}
            />
            <hr style={{margin:'0px',borderColor:'black'}}/>
            <p style={{color:'rgba(0, 0, 0, 0.6)',fontSize:'12px'}}>Filter Mode: Less Than</p>
          </LocalizationProvider>
          
        ),
      },
      {
        accessorKey: 'updatedat',
        header:  "Updated Date",
        enableColumnFilterModes: true,
        filterFn: 'lessThan',
        columnFilterModeOptions: ['equals', 'lessThan', 'greaterThan'],
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue() && cell.getValue().length>0 ? <Moment date={cell.getValue()} format="YYYY-MM-DD HH:mm:ss"/> : ""}</Typography>
        ),
        Filter: ({ column, header, table }) => ( 
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <input
              type="date"
              style={{margin:'6px 10px 3px 0',border:'1px solid #ddd',padding:'4px 0',color:'#777',fontSize:'13px'}}
              onChange={(newValue) => {
                column.setFilterValue(newValue.target.value);
              }}
              value={column.getFilterValue()}
            />
            <hr style={{margin:'0px',borderColor:'black'}}/>
            <p style={{color:'rgba(0, 0, 0, 0.6)',fontSize:'12px'}}>Filter Mode: Less Than</p>
          </LocalizationProvider>
          
        ),
      },
      {
        accessorKey: 'status',
        header:  "Status",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: false,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      }
      //end
    ],
    [],
  );

  const reloadDataAndCloseModal =()=>{
    setNewRequest(false);
    fetchDataFromAPI();
  }

  // useEffect(() => {
  //   if(showDetailsId){
  //       setExistRequest(true)
  //       setShowDetailsId(false)
  //   }
  // }, [showDetailsId]);

  return (
    <>
      <div className="toolbar">
          <div className="row">
              {/* {AuthVerify.getPermissions("Catalog")?.addnew && */}
                  <div className="col-sm-3 text-right" style={{ float: "right" }}>
                      <a href="#" onClick={() => setNewRequest(true)}>+ Add New</a>
                  </div>
                  {/* } */}
          </div>
      </div>
        <MaterialReactTable
          columns={columns}
          data={data}
          enableColumnActions={false}
          enableGlobalFilter={false}
          enableColumnFilterModes
          initialState={{
            showColumnFilters: false
          }}
          manualFiltering
          manualPagination
          manualSorting
          onColumnFilterFnsChange={setColumnFilterFns}
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          tableInstanceRef={tableInstanceRef}
          rowCount={rowCount}
          enableEditing
          state={{
            columnFilters,
            columnFilterFns,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
          }}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            'mrt-row-actions': {
              header: 'Action', //change header text
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Details">
                <IconButton onClick={() => {navigate(`/my-request-details?refnum=${row.original.refnum}`);}}>
                  <List />
                </IconButton>
              </Tooltip>
            </Box>
          )}
          muiTableHeadCellProps={{
            sx: {
              // fontWeight: 'bold',
              fontSize: '15px',
            },
          }}
          muiTablePaginationProps={{
            sx: {
              fontWeight: 'bold',
              paddingTop: '12px',
              fontSize: '16px',
            },
          }}
          muiTableBodyCellEditTextFieldProps={({ cell, column, row, table }) => ({
            sx: {
              fontSize: '17px'
            },
          })}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              fontWeight: 'bold',
              fontSize: '17px',
            },
          }}
        />
        {/* <div className="cart_navigation">
          <button className="button btn-proceed-checkout" title="Proceed to Save the Changes" type="button" onClick={() => saveChangesHandler()}><span>Save Changes</span></button>
        </div> */}

      <Modal show={newRequest} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setNewRequest(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>New Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Request callBack={reloadDataAndCloseModal}/>
        </Modal.Body>
      </Modal>

      <Modal show={existRequest} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setExistRequest(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Request Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Request showDetailsId={showDetailsId} callBack={setExistRequest}/>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CustomTable;
